module.exports = __webpack_public_path__ + "static/media/minster1_000_ortf_48k.3a18b009.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/minster1_000_ortf_48k.wav
// module id = 283
// module chunks = 0